import React from 'react';
import './error.css';
import { Link } from 'react-router-dom';

const Error404 = () => {
  return (
    <div className='container error_container'>
        <div className='row'>
            <div className='col-12'>
                <center>
                    <div className='image'>
                        <i className='icon-window-error'></i>
                    </div>
                    <h1>Error 404: Página no encontrada</h1>
                    <p>Lo siento, la página que está buscando no existe.</p>
                    <Link className='btn_error' to="/" >INICIO</Link>
                </center>
            </div>
        </div>
    </div>
  )
}

export default Error404